import { render, staticRenderFns } from "./InvoiceCompanyDetails.vue?vue&type=template&id=31aa0d0e&"
import script from "./InvoiceCompanyDetails.vue?vue&type=script&lang=js&"
export * from "./InvoiceCompanyDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports